/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { VersionHistoryEntry } from './versionHistoryEntry';

export type ModuleLecturerResponseVersionHistory = { [key: string]: VersionHistoryEntry };
